var _rect, _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnActiveSwitch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 26,
    viewBox: "0 0 55 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 53,
    height: 22,
    rx: 11,
    fill: "#262626"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1031_8607)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1031_8607)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 18,
    height: 18,
    rx: 9,
    fill: "#EB5757"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.0312 10.4648V11.0039C35.0312 11.6445 34.9512 12.2188 34.791 12.7266C34.6309 13.2344 34.4004 13.666 34.0996 14.0215C33.7988 14.377 33.4375 14.6484 33.0156 14.8359C32.5977 15.0234 32.1289 15.1172 31.6094 15.1172C31.1055 15.1172 30.6426 15.0234 30.2207 14.8359C29.8027 14.6484 29.4395 14.377 29.1309 14.0215C28.8262 13.666 28.5898 13.2344 28.4219 12.7266C28.2539 12.2188 28.1699 11.6445 28.1699 11.0039V10.4648C28.1699 9.82422 28.252 9.25195 28.416 8.74805C28.584 8.24023 28.8203 7.80859 29.125 7.45312C29.4297 7.09375 29.791 6.82031 30.209 6.63281C30.6309 6.44531 31.0938 6.35156 31.5977 6.35156C32.1172 6.35156 32.5859 6.44531 33.0039 6.63281C33.4258 6.82031 33.7871 7.09375 34.0879 7.45312C34.3926 7.80859 34.625 8.24023 34.7852 8.74805C34.9492 9.25195 35.0312 9.82422 35.0312 10.4648ZM33.9121 11.0039V10.4531C33.9121 9.94531 33.8594 9.49609 33.7539 9.10547C33.6523 8.71484 33.502 8.38672 33.3027 8.12109C33.1035 7.85547 32.8594 7.6543 32.5703 7.51758C32.2852 7.38086 31.9609 7.3125 31.5977 7.3125C31.2461 7.3125 30.9277 7.38086 30.6426 7.51758C30.3613 7.6543 30.1191 7.85547 29.916 8.12109C29.7168 8.38672 29.5625 8.71484 29.4531 9.10547C29.3438 9.49609 29.2891 9.94531 29.2891 10.4531V11.0039C29.2891 11.5156 29.3438 11.9688 29.4531 12.3633C29.5625 12.7539 29.7188 13.084 29.9219 13.3535C30.1289 13.6191 30.373 13.8203 30.6543 13.957C30.9395 14.0938 31.2578 14.1621 31.6094 14.1621C31.9766 14.1621 32.3027 14.0938 32.5879 13.957C32.873 13.8203 33.1133 13.6191 33.3086 13.3535C33.5078 13.084 33.6582 12.7539 33.7598 12.3633C33.8613 11.9688 33.9121 11.5156 33.9121 11.0039ZM37.8555 6.46875V15H36.7246V6.46875H37.8555ZM41.4297 10.3066V11.2324H37.6094V10.3066H41.4297ZM42.0098 6.46875V7.39453H37.6094V6.46875H42.0098ZM44.4883 6.46875V15H43.3574V6.46875H44.4883ZM48.0625 10.3066V11.2324H44.2422V10.3066H48.0625ZM48.6426 6.46875V7.39453H44.2422V6.46875H48.6426Z",
    fill: "#EB5757"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1031_8607",
    x: 0,
    y: 0,
    width: 26,
    height: 26,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0.137255 0 0 0 0 0.0431373 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1031_8607"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1031_8607",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1031_8607"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 2,
    width: 18,
    height: 18,
    rx: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnActiveSwitch);
export default __webpack_public_path__ + "static/media/UnActiveSwitch.24a6ee55fe60a184f0cd1ea83155e859.svg";
export { ForwardRef as ReactComponent };